export function obDefaultValGet(ob, key, defaultVal = '') {
    let val = defaultVal;
    if (ob !== null) {
        val = (ob.hasOwnProperty(key) ? ob[key] : defaultVal);
    }
    return val;
}

export function apiUrlBaseGet(versionIncluded=true) {
    let url;
    const loc = window.location.href + '';
    if (loc.includes('localhost')) {
        url = 'http://localhost:3000';
    } else if (loc.includes('t.sumgame')) {
        url = 'http://localhost:3000';
    } else if (loc.includes('sumgame')) {
        url = 'https://sumgame.emlearn.info';
    }
    if (versionIncluded) {
        url += '/api/v1';        
    }
    return url;
}

export function apiUrlIOGet() {
    let url;
    const loc = window.location.href + '';
    if (loc.includes('localhost')) {
        url = 'http://localhost:3002';
    } else if (loc.includes('t.sumgame')) {
        url = 'http://t.sumgame.emlearn.info';
    } else if (loc.includes('sumgame')) {
        url = 'https://sumgame.emlearn.info';
    }
    return url;
}

export function apiUrlWSGet() {
    let url;
    const loc = window.location.href + '';
    if (loc.includes('localhost')) {
        url = 'ws://localhost:3002';
    } else if (loc.includes('t.sumgame')) {
        url = 'wss://t.sumgame.emlearn.info/ws';
    } else if (loc.includes('sumgame')) {
        url = 'wss://sumgame.emlearn.info/ws';
    }
    return url;
}

export function apiUrlGet(path) {
    let url = apiUrlBaseGet();
    url += '/' + path;
    return url;
}

